import { AuthToken } from '@/auth/AuthToken';
import { Config } from '@/config'
import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink, concat } from '@apollo/client/core'

export const getApolloClient = async () => {
  await Config.init();

  const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: {
        authorization: `Bearer ${AuthToken.getAuthToken()}`
      }
    });

    return forward(operation);
  });

  const httpLink = createHttpLink({
    uri: Config.getConfig().API_URL,
  });

  const cache = new InMemoryCache();

  const apolloClient = new ApolloClient({
    link: concat(authMiddleware, httpLink),
    cache,
    defaultOptions: {
      watchQuery: {
        fetchPolicy: 'network-only',
      },
      query: {
        fetchPolicy: 'network-only',
      }
    }
  });

  return apolloClient
}
